export { WebVitalsInstrumentation } from './instrumentation';



// WEBPACK FOOTER //
// ../../../../src/instrumentations/webVitals/index.ts